import React from 'react';

const AdminModal = ({
  show,
  title,
  description,
  children,
  footerContent,
  size = '',
  centered = false,
  onClose,
  isUsingLine = false
}) => {
  return (
    <>
      <div
        className={`modal fade ${show ? 'show d-block' : ''}`}
        tabIndex="-1"
        style={show ? { backgroundColor: 'rgba(0, 0, 0, 0.5)' } : {}}
        aria-labelledby="sharedModalLabel"
        aria-hidden={!show}
      >
        <div
          className={`modal-dialog ${size} ${centered ? 'modal-dialog-centered' : ''}`} // Conditionally add centering class
        >
          <div className="modal-content">
            <div className="modal-body m-3">
              <div className="d-flex justify-content-between align-items-start">
                {title && (
                  <div className="modal-title">
                    <label className='fs-18 tw:!font-bold mb-0'>{title}</label>
                    {description && (
                      <p className="text-info-card-cart">
                        {description}
                      </p>
                    )}
                  </div>
                )}
                <button
                  type="button"
                  className="btn-close ms-auto"
                  aria-label="Close"
                  onClick={onClose}
                ></button>
              </div>
              {
                isUsingLine && (
                  <hr className="tw:!border tw:!border-[0.5] tw:!border-[#E8E8E8]"/>
                )
              }
              <div className="mt-0">
                {children}
              </div>
            </div>
            {footerContent && <div className="modal-footer">{footerContent}</div>}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminModal;
